import React, { useState } from "react";
import HistoryItem from "./HistoryItem";
import ResizesModal from "./ResizesModal";

function LibrarySection({ generations, onNewCreative }) {
  const [viewingResizes, setViewingResizes] = useState(null);

  if (!generations || generations.length === 0) {
    return (
      <div className="aic-library-empty">
        <div className="aic-library-empty__icon">
          <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
            <rect width="48" height="48" rx="12" fill="#f0f4ff"/>
            <rect x="10" y="14" width="28" height="20" rx="3" fill="#dce8ff"/>
            <rect x="14" y="18" width="10" height="2" rx="1" fill="#3f73f9" opacity="0.5"/>
            <rect x="14" y="22" width="20" height="1.5" rx="0.75" fill="#3f73f9" opacity="0.3"/>
            <rect x="14" y="25" width="14" height="1.5" rx="0.75" fill="#3f73f9" opacity="0.2"/>
            <circle cx="34" cy="26" r="7" fill="#3f73f9" opacity="0.15"/>
            <path d="M31 26l2 2 4-4" stroke="#3f73f9" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
        <h4 className="aic-library-empty__title">Библиотека пуста</h4>
        <p className="aic-library-empty__text">
          Здесь будут храниться все ваши сгенерированные<br />баннеры с ресайзами и датами создания
        </p>
        <button className="aic-btn aic-btn--primary" onClick={onNewCreative}>
          Создать первый баннер
        </button>
      </div>
    );
  }

  const recentGenerations = generations.slice(0, 5);
  const allGenerations = generations;

  return (
    <div className="aic-library">
      {recentGenerations.length > 0 && (
        <section className="aic-library__section">
          <div className="aic-library__section-header">
            <h3 className="aic-library__section-title">История генераций</h3>
            <span className="aic-library__section-count">{recentGenerations.length} из {allGenerations.length}</span>
          </div>
          <div className="aic-library__history-list">
            {recentGenerations.map((gen) => (
              <HistoryItem
                key={gen.id}
                generation={gen}
                onViewResizes={(g) => setViewingResizes(g)}
              />
            ))}
          </div>
        </section>
      )}

      {allGenerations.length > 5 && (
        <section className="aic-library__section">
          <div className="aic-library__section-header">
            <h3 className="aic-library__section-title">Все креативы</h3>
            <span className="aic-library__section-count">{allGenerations.length}</span>
          </div>
          <div className="aic-library__grid">
            {allGenerations.map((gen) => (
              <LibraryCard
                key={gen.id}
                generation={gen}
                onView={() => setViewingResizes(gen)}
              />
            ))}
          </div>
        </section>
      )}

      {viewingResizes && (
        <ResizesModal
          resizes={viewingResizes.resizes || []}
          isLoading={false}
          selectedVariant={viewingResizes.variants?.find((v) => v.id === viewingResizes.selectedVariantId)}
          formData={viewingResizes.formData}
          onClose={() => setViewingResizes(null)}
          onSaveToLibrary={() => setViewingResizes(null)}
        />
      )}
    </div>
  );
}

function LibraryCard({ generation, onView }) {
  const date = new Date(generation.createdAt);
  const dateStr = date.toLocaleDateString("ru-RU", { day: "2-digit", month: "short" });

  const selected = generation.variants?.find((v) => v.id === generation.selectedVariantId) || generation.variants?.[0];
  const STYLE_COLORS = {
    minimal: "#f0f4ff",
    vivid: "linear-gradient(135deg, #ff6b35, #f7c59f)",
    premium: "linear-gradient(135deg, #1a1a2e, #0f3460)",
  };

  return (
    <div className="aic-lib-card">
      <div
        className="aic-lib-card__preview"
        style={{ background: STYLE_COLORS[selected?.style] || "#f0f4ff" }}
      >
        {selected?.imageUrl ? (
          <img src={selected.imageUrl} alt="" className="aic-lib-card__img" />
        ) : (
          <div className="aic-lib-card__mock-text">
            <span>{generation.formData?.brandName}</span>
          </div>
        )}
      </div>
      <div className="aic-lib-card__info">
        <div className="aic-lib-card__brand">{generation.formData?.brandName}</div>
        <div className="aic-lib-card__date">{dateStr}</div>
      </div>
      {generation.resizes?.length > 0 && (
        <button className="aic-lib-card__btn" onClick={onView}>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" stroke="currentColor" strokeWidth="2"/>
            <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="2"/>
          </svg>
          Смотреть
        </button>
      )}
    </div>
  );
}

export default LibrarySection;
